import React from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useAddPaymentMethodMutation } from "api/payment.js";
import { Box, CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "400px",
  margin: "0 auto",
};

const cardElementContainerStyle = {
  border: "1px solid #ccc",
  borderRadius: "4px",
  padding: "8px",
  marginBottom: "16px",
};

const cardElementOptions = {
  // Add any specific styling for the CardElement here, if required.
};

const submitButtonStyle = {
  backgroundColor: "#2B817B",
  color: "#FFF",
  padding: "8px 16px",
  borderRadius: "4px",
  cursor: "pointer",
  border: "none",
  "&:hover": {
    backgroundColor: "#2B817B",
  },
  fontFamily: "Outfit",
};

const StripePayment = ({ handleClose }) => {
  const stripe = useStripe();
  const elements = useElements();
  let [addPaymentMethod, { isLoading }] = useAddPaymentMethodMutation();

  const handleSaveCardDetails = async (event) => {
    // const token = localStorage.getItem("token")
    // console.log(token)
    event.preventDefault();
    try {
      // Create a card token using the Stripe card element
      const cardElement = elements.getElement(CardElement);
      const { token } = await stripe.createToken(cardElement);
      console.log("token", token);

      await addPaymentMethod({ paymentToken: token.id }).then((res) => {
        console.log(res);

        handleClose();
        if (res.data) {
          Swal.fire("Card Added Successfully!", "", "success");
        } else {
          console.log("res.error.data");
          console.log(res.error.data.message);
          Swal.fire(res.error.data.message, "", "error");
        }
      });

      // console.log("Card details saved successfully.");
    } catch (error) {
      console.error(error.message);
      // Swal.fire(error.message, "", "error");

    }
  };

  return isLoading ? (
    <Box display="flex" justifyContent="center" alignItems="center">
      <CircularProgress />
    </Box>
  ) : (
    <form onSubmit={handleSaveCardDetails}>
      <div style={containerStyle}>
        <div style={cardElementContainerStyle}>
          <CardElement options={cardElementOptions} />
        </div>
        <button type="submit" style={submitButtonStyle}>
          Save Card Details
        </button>
      </div>
    </form>
  );
};

export default StripePayment;
